<template>
  <div class="layout-wrap" :class="side">
    <div ref="sidebar"
         v-click-outside="pushOut"
         class="push-sidebar"
         :class="{collapsible}">
      <div class="toggle-wrap">
        <button v-if="collapsible" class="secondary" @click="toggle">
          <i :class="open?'arrow-left':'burger'" class="small"/>
        </button>
      </div>
      <div class="sidebar-content">
        <slot name="sidebar"/>
      </div>
    </div>
    <div class="layout-content-wrap" :class="{collapsible}">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
  name: 'LayoutWithPushSidebar',
  directives: { ClickOutside },
  props: {
    side: { type: String, default: 'left', validator: v => ['left', 'top', 'right', 'bottom'].includes(v) }
  },

  data: () => ({
    collapsible: false,
    open: true,
    contentMinWidth: 550
  }),

  computed: {
    flow () {
      return this.side === 'left' || this.side === 'right' ? 'row' : 'column'
    }
  },

  watch: {
    collapsible (val) {
      if (!val) {
        this.pushIn()
      }
    }
  },

  mounted () {
    this.setSidebarCollapsible()
    window.addEventListener('resize', this.setSidebarCollapsible)
  },

  methods: {
    setSidebarCollapsible () {
      const maxWidth = this.$refs.sidebar.getBoundingClientRect().width + this.contentMinWidth
      this.collapsible = window.innerWidth < maxWidth
      if (this.collapsible && this.open) {
        this.pushOut()
      }
      if (!this.collapsible && !this.open) {
        this.pushIn()
      }
    },

    toggle (e) {
      this.open = !this.open
      this.setPushMargin()
    },

    pushOut () {
      if (this.collapsible) {
        this.open = false
        this.setPushMargin()
      }
    },

    pushIn () {
      this.open = true
      this.setPushMargin()
    },

    setPushMargin () {
      const sidebar = this.$refs.sidebar
      let size
      if (this.side === 'left' || this.side === 'right') {
        size = this.open ? 0 : -sidebar.getBoundingClientRect().width
      } else {
        size = this.open ? 0 : -sidebar.getBoundingClientRect().height
      }
      document.documentElement.style.setProperty(`--push-margin-${this.side}`, `${size}px`)
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../scss/vars";

  $max-width-disable: 800px;
  $transition-time: 0.15s;

  .layout-wrap {
    height: 100%;
    display: flex;

    &.top, &.bottom {
      flex-flow: column;
    }
    &.left {
      margin-left: var(--push-margin-left);
      transition: margin-left $transition-time;
    }
    &.right {
      margin-right: var(--push-margin-right);
      transition: margin-right $transition-time;
    }
    &.top {
      margin-top: var(--push-margin-top);
      transition: margin-top $transition-time;
    }
    &.bottom {
      margin-bottom: var(--push-margin-bottom);
      transition: margin-bottom $transition-time;
    }

    &.left, &.right {
      .layout-content-wrap, .sidebar {
        height: 100%;
      }
    }

    .layout-content-wrap {
      flex-grow: 1;
      overflow: hidden;
      &.collapsible {
        width: 100vw;
        min-width: 100vw;
      }
    }

    .push-sidebar {
      flex-shrink: 0;
      overflow: auto;

      .toggle-wrap {
        button {
          position: fixed;
          z-index: 1000;
        }
      }
      .toggle-wrap {
        height: $basic-size;

        button {
          background: transparentize($dark-bg, 0.15);
        }

        button:after {
          content: '';
          position: absolute;
          width: 75%;
          height: 75%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          background: $px-color-grey;
          z-index: -1;
        }
      }
    }

    &.left {
      .toggle-wrap button { left: 0; }
    }
    &.right {
      .toggle-wrap button { right: 0; }
    }
    &.top {
      .toggle-wrap button { top: 0; }
    }
    &.bottom {
      .toggle-wrap button { bottom: 0; }
    }
  }
</style>
